/** Maximum number of file attachments allowed per issue report. Used by UI and store validation. */
export const MAX_ATTACHMENTS = 5;
